import React, { useEffect, useState } from "react";
import { getOrderDetail, getOrderDetailByAdmin } from "../../../../services/LocationService";
import { PriceDetail } from "../../../../models/Order";

export default function useOrderDetail(props: { id: string; openDialog: boolean }) {
	const [orderDetail, setOrderDetail] = useState<PriceDetail>();
	const loadOrder = async () => {
		try {
			var res = await getOrderDetailByAdmin(props.id);

			setOrderDetail(res);
		} catch (err) {
			console.error(err);
		}
	};
	const reload = () => {
		loadOrder();
	};
	useEffect(() => {
		if (props.id && props.id != "0") {
			reload();
		}
	}, [props.id]);
	return {
		orderDetail,
	};
}
